import { render, staticRenderFns } from "./InscriptionListView.vue?vue&type=template&id=23fefc98&scoped=true&"
import script from "./InscriptionListView.vue?vue&type=script&lang=js&"
export * from "./InscriptionListView.vue?vue&type=script&lang=js&"
import style0 from "./InscriptionListView.vue?vue&type=style&index=0&id=23fefc98&prod&lang=css&scoped=true&"
import style1 from "./InscriptionListView.vue?vue&type=style&index=1&id=23fefc98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fefc98",
  null
  
)

export default component.exports